// This is the entry point for the Basic plugin. The `atoms`, `elementPresets`,
// `icons`, etc... that make up this plugin are primarily found in the Basic
// package. However, because this plugin requires two dataTypes that are either
// Dangerous or Custom and also depend on core, we're keeping this here until we
// implement a solution.
import {Basic} from '@packages/systems/core/plugins';
import {Plugins} from '@packages/systems/wfdl';
import {RichTextChildren} from './dataTypes/RichTextChildren';
import {SwitchLabelType} from './dataTypes/SwitchLabelType';
import {Link} from './dataTypes/Link';
import {
  CartTypeEnum,
  CartStatesEnum,
  CartStatesEmptyEnum,
} from './dataTypes/CartEnum';
import {LinkPageSelectorType} from './dataTypes/LinkPageSelectorType';
import {MultilineTextType} from './dataTypes/MultilineTextType';
import OnBlurText from './dataTypes/OnBlurText';
import {IdTextInputType} from './dataTypes/IdTextInputType';
import {CustomAttributeType} from './dataTypes/CustomAttributeType';
import {DisplayNameType} from './dataTypes/DisplayNameType';
import {TagType} from './dataTypes/TagType';
import {AttributesType} from './dataTypes/AttributesType';

// @ts-expect-error - TS2345 - Argument of type '{ dataTypes: { RichTextChildren: TypeImplementation; Link: TypeImplementation; LinkPageSelectorType: TypeImplementation; ... 24 more ...; SliderSearchResultsLength: TypeImplementation; }; components: { ...; }; atoms: { ...; }; icons: { ...; }; elementPresets: { ...; }; }' is not assignable to parameter of type 'PrivilegedPluginType'.
export const plugin = Plugins.PrivilegedPlugin({
  ...Basic,
  dataTypes: {
    ...Basic.dataTypes,
    TagType,
    RichTextChildren,
    Link,
    LinkPageSelectorType,
    SwitchLabelType,
    MultilineText: MultilineTextType,
    CartTypeEnum,
    CartStatesEnum,
    CartStatesEmptyEnum,
    OnBlurText,
    IdTextInput: IdTextInputType,
    CustomAttribute: CustomAttributeType,
    Attributes: AttributesType,
    DisplayName: DisplayNameType,
  },
});
